type MicroAppEventCenter = {
  dispatch?: (data: Record<string, unknown>) => void
  forceDispatch?: (data: Record<string, unknown>) => void
}

function reloadTopLevelWindow() {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.reload()
      return true
    }
  } catch (error) {
    console.warn('top-level reload failed, fallback to current window', error)
  }

  return false
}

/**
 * 浏览器级整页重载（与地址栏刷新等价），不经过微前端 `dispatch({ type: 'reload' })` 的软重载。
 * 切换企业等场景使用：软重载易残留 antd/rc 浮层状态，导致 Tooltip 等出现 getComputedStyle(null)。
 */
export function reloadCurrentAppHard() {
  if (reloadTopLevelWindow()) {
    return
  }
  window.location.reload()
}

export function reloadCurrentApp() {
  const microAppEventCenter = (window as any).microApp as MicroAppEventCenter | undefined
  const dispatch = microAppEventCenter?.forceDispatch || microAppEventCenter?.dispatch

  if (dispatch) {
    dispatch.call(microAppEventCenter, {
      type: 'reload'
    })
    return
  }

  reloadCurrentAppHard()
}
